<div class="master__footer">
  <div class="container__footer">
    <!-- Logo -->
    <div class="container__logo">
      <img class="logo" src="./../../assets/images/logo-footer.svg">
      <div class="social__footer">
        <a href="https://facebook.com/" target="_blank"><img class="items__footer"
            src="./../../assets/images/icon-facebook.svg"></a>
        <a href="https://youtube.com/" target="_blank"><img class="items__footer"
            src="./../../assets/images/icon-youtube.svg"></a>
        <a href="http://twitter.com/" target="_blank"><img class="items__footer"
            src="./../../assets/images/icon-twitter.svg"></a>
        <a href="https://www.pinterest.it/" target="_blank"><img class="items__footer"
            src="./../../assets/images/icon-pinterest.svg"></a>
        <a href="https://instagram.com/" target="_blank"><img class="items__footer"
            src="./../../assets/images/icon-instagram.svg"></a>
      </div>
    </div>

    <!-- Menu -->
    <div class="container__menu__footer">
      <div class="menu">
        <span class="items__menu">About Us</span>
        <span class="items__menu">Contact</span>
        <span class="items__menu">Blog</span>
      </div>
      <div class="menu --margin">
        <span class="items__menu">Carrers</span>
        <span class="items__menu">Support</span>
        <span class="items__menu">Privacy Policy</span>
      </div>
    </div>

    <!-- button request  -->
    <div class="container__button">
      <div>
        <button class="button__header">
          <span class="span__header">Request Invite</span>
        </button>
      </div>
      <span class="copyrigth__footer">© Easybank. All Rigths Reserved</span>
    </div>

  </div>
</div>
